<template>
  <v-dialog v-model="showDialog" width="500">
    <v-card class="pa-4">
      <v-card-title class="ma-0 mb-2 pa-0">
        <h2>{{title}}</h2>
      </v-card-title>
      <v-card-text class="ma-0 mt-2 mb-1 pa-0">
        <p>{{message}}</p>
      </v-card-text>
      <v-card-actions class="ma-0 mt-3 pa-0">
        <v-btn @click="confirm()" id="sla-dialog-delete-btn" color="error"
          >{{confirmButtonLabel}}</v-btn
        >
        <v-btn
          @click="cancel()"
          id="bucket-delete-dialog-cancel-btn"
          color="secondary"
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    confirmButtonLabel: {
      type: String,
      required: true
    }
  },
  methods: {
    confirm() {
      this.$emit("confirm")
    },
    cancel() {
      this.$emit("cancel")
    }
  }
}
</script>